import React from "react";
import { Button } from "@mui/material";
import AddCommentOutlinedIcon from "@mui/icons-material/AddCommentOutlined";

const OutlinedAddButton = ({
  label,
  variant = "outlined",
  startIcon = <AddCommentOutlinedIcon />,
  onClick,
  disabled = false,
  sx = {},
  ...props
}) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      startIcon={startIcon}
      disabled={disabled}
      {...props}
      sx={{ pt: 1, pb: 1, pl: 4, pr: 4, color: 'rgba(36,93,173,1)', borderRadius: 8, borderColor: 'rgba(36,93,173,1)',...sx }}
    >
      {label}
    </Button>
  );
};

export default OutlinedAddButton;
